// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1pKKf","fileDisabled":"File_fileDisabled__10NAe"};